<template>
  <div>
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon feather-mail.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">お問い合わせ</p>
    </div>
    <div class="container">
      <div class="guidance">
        <h5>以下の項目についてご記入ください</h5>
      </div>
      <ValidationObserver v-slot="{ handleSubmit, invalid }">
        <form @submit.prevent="handleSubmit">
          <div class="form-container">
            <ValidationProvider
              :rules="{ required_select: { allowFalse: false } }"
              v-slot="{ classes, invalid, errors }"
            >
              <div class="headline">ご利用のサービス<span class="bg-red">必須</span></div>
              <div class="option-box">
                <div v-for="(service, index) in services" :key="index" name="usingServise">
                  <label class="option" :class="classes">
                    <input type="checkbox" :value="service" v-model="inquiryData.usingService" />
                    <span>{{ service }}</span>
                  </label>
                </div>
              </div>
              <div class="caution">※お問い合わせの対象となるサービスをお選びください</div>
              <p class="invalid-feedback">{{ errors[0] }}</p>
            </ValidationProvider>
            <ValidationProvider
              :rules="{ required_select: { allowFalse: false } }"
              v-slot="{ classes, invalid, errors }"
            >
              <div class="headline">お問い合わせ内容<span class="bg-red">必須</span></div>
              <div class="option-box">
                <div v-for="(content, index) in inquiryContents" :key="index" name="inquiryContent">
                  <label class="option" :class="classes">
                    <input type="radio" :value="content" v-model="inquiryData.inquiryContent" />
                    <span>{{ content }}</span>
                  </label>
                </div>
              </div>
              <p class="invalid-feedback">{{ errors[0] }}</p>
            </ValidationProvider>
            <ValidationProvider rules="required" mode="eager" v-slot="{ classes, invalid, errors }">
              <div class="headline">詳細１<span class="bg-red">必須</span></div>
              <input
                :class="classes"
                v-model="inquiryData.detail_1"
                type="text"
                placeholder="画面内容を入力してください"
              />
              <div class="caution">
                該当する画面の内容をお知らせください。<br />
                例）生徒のログイン画面
              </div>
              <p class="invalid-feedback">{{ errors[0] }}</p>
            </ValidationProvider>
            <ValidationProvider rules="required" mode="eager" v-slot="{ classes, invalid, errors }">
              <div class="headline">詳細２<span class="bg-red">必須</span></div>
              <textarea
                :class="classes"
                v-model="inquiryData.detail_2"
                placeholder="お問い合わせ内容を入力してください"
              />
              <div class="caution">
                できるだけ詳しく内容をお教えください。また、発生頻度もあわせてお知らせください。<br />
                例）正しいIDとパスワードを入力したのにログインできず、何度試しても黄色い画面だけが表示される
              </div>
              <p class="invalid-feedback">{{ errors[0] }}</p>
            </ValidationProvider>
            <ValidationProvider rules="required" mode="eager" v-slot="{ classes, invalid, errors }">
              <div class="headline">発生日時<span class="bg-red">必須</span></div>
              <input
                :class="classes"
                v-model="inquiryData.datetime"
                type="text"
                placeholder="4月1日 11:00〜11:30ごろ"
              />
              <div class="caution">
                お問い合わせの現象を確認された日時をお知らせください。
              </div>
              <p class="invalid-feedback">{{ errors[0] }}</p>
            </ValidationProvider>
            <div class="not-require">
              <div class="headline">ご利用の端末・ブラウザ<span class="bg-gray">任意</span></div>
              <input v-model="inquiryData.device" type="text" placeholder="第7世代iPad iOS14.4、GoogleChrome" />
              <div class="caution">
                端末情報、ブラウザ情報についてお知らせください。
              </div>
            </div>
            <div class="not-require">
              <div class="headline">ご利用のログインID<span class="bg-gray">任意</span></div>
              <input v-model="inquiryData.userId" type="text" placeholder="生徒ID: Tamaishiki01" />
              <div class="caution">
                お問い合わせいただいた現象の対象となるIDとID種別（法人／ブランド／教場／先生／生徒
                のいずれか）をご入力ください。
              </div>
            </div>
            <ValidationProvider rules="required" mode="eager" v-slot="{ classes, invalid, errors }">
              <div class="headline">あなたのお名前<span class="bg-red">必須</span></div>
              <input :class="classes" v-model="inquiryData.name" type="text" placeholder="玉井 太郎" />
              <p class="invalid-feedback">{{ errors[0] }}</p>
            </ValidationProvider>
            <ValidationProvider rules="required" mode="eager" v-slot="{ classes, invalid, errors }">
              <div class="headline">会社名、または塾・幼稚園などのお名前<span class="bg-red">必須</span></div>
              <input :class="classes" v-model="inquiryData.corporation" type="text" placeholder="株式会社 ◯◯◯" />
              <p class="invalid-feedback">{{ errors[0] }}</p>
            </ValidationProvider>
            <ValidationProvider rules="required" mode="eager" v-slot="{ classes, invalid, errors }">
              <div class="headline">ご連絡先（電話番号）<span class="bg-red">必須</span></div>
              <input :class="classes" v-model="inquiryData.tel" type="text" placeholder="075-xxx-xxx" />
              <p class="invalid-feedback">{{ errors[0] }}</p>
            </ValidationProvider>
            <ValidationProvider rules="required|email" mode="eager" v-slot="{ classes, invalid, errors }">
              <div class="headline">ご連絡先（メールアドレス）<span class="bg-red">必須</span></div>
              <input :class="classes" v-model="inquiryData.email" type="text" placeholder="tamaishiki@example.com" />
              <p class="invalid-feedback">{{ errors[0] }}</p>
            </ValidationProvider>
            <div class="not-require">
              <div class="headline">お試しいただいた項目<span class="bg-gray">任意</span></div>
              <div class="option-box">
                <div v-for="(tried, index) in tries" :key="index" name="usingServise">
                  <label class="option">
                    <input type="checkbox" :value="tried" v-model="inquiryData.tried" />
                    <span>{{ tried }}</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="not-require">
              <div class="headline">
                撮影いただいた画像などをお送りいただけると幸いです<span class="bg-gray">任意</span>
              </div>
              <div class="option no-pointer">
                <input
                  type="file"
                  id="file"
                  accept="image/*,.heic,video/.m4v,.mp4,.mov,.qt,application/pdf"
                  @change="changeFile"
                />
                <span class="deletefile-text" v-if="hasFile" @click="deleteFile">ファイルを削除</span>
              </div>
              <div class="caution">
                ※ファイルの拡張子はイメージファイル（.png、.jpg、.gif、.HEICなど）やムービーファイル（.mp4、.m4v、.mov、.qt）、PDFのみ<br />
                ※ファイルサイズは20MBまで
              </div>
            </div>
            <div class="send">
              <button class="btn" :disabled="invalid" type="button" @click="sendEmail">
                {{ invalid ? '未入力の項目があります' : '送信' }}
              </button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
    <PopUpHolder
      ref="popup_holder_success"
      no-close-on-esc
      no-close-on-backdrop
      green-button-title="トップへ戻る"
      @greenClick="backToTop"
    >
      <template v-slot:header>お問い合わせを承りました</template>
      <template v-slot:body
        >ご入力いただいたメールアドレスに、お問い合わせ内容を送信いたしました。内容をご確認ください。<br />※自動返信メールの到着まで時間がかかる場合がございます。</template
      >
    </PopUpHolder>
    <PopUpHolder
      ref="popup_holder_faild"
      no-close-on-esc
      no-close-on-backdrop
      green-button-title="戻る"
      @greenClick="backToContact"
    >
      <template v-slot:header>お問い合わせ中にエラーが発生いたしました</template>
      <template v-slot:body
        >大変申し訳ございません。入力内容をご確認の上、もう一度お試しください。<br />何度もエラーが発生する場合はお手数をおかけしますが、以下のメールアドレスにお問い合わせ内容をご記入の上、直接ご送信ください。<br />
        inquiry@tamaishiki.com</template
      >
    </PopUpHolder>
  </div>
</template>

<script>
// import store from '@/store/index.js';
import { ValidationObserver } from 'vee-validate';
import { ValidationProvider } from 'vee-validate';
import { mapState } from 'vuex';
import { currentUser } from '@/helpers/Authentication.js';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import MailService from '@/services/MailService.js';

export default {
  data() {
    return {
      file: null,
      inquiryData: {
        usingService: [],
        tried: [],
      },
      services: ['AAA生徒用（アプリ版）', 'AAA生徒用（ブラウザ版）', 'AAA管理画面', 'AAA先生用'],
      inquiryContents: ['不具合に関するお問い合わせ', 'ご要望・その他'],
      tries: ['ブラウザの画面更新（リロード）', 'キャッシュクリア', 'アプリの再起動', '端末の再起動'],
    };
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    PopUpHolder,
  },
  computed: {
    hasFile() {
      return this.file;
    },
    currentIDTypeTitle() {
      return this.role.currentRole.idTypeTitle;
    },
    ...currentUser,
    ...mapState(['role']),
  },
  methods: {
    buildClasses(veeClasses) {
      let veeClassesActive = Object.keys(veeClasses).filter((key) => veeClasses[key]);
      veeClassesActive = this.isRequired || (this.value && veeClasses.validated) ? veeClassesActive : {};
      return ['form-control', 'no-padding', this.inputClass].concat(Object.values(veeClassesActive)).join(' ');
    },
    changeFile(event) {
      if (!event.target.files[0]) {
        this.file = null;
        return;
      }
      const fileSize = event.target.files[0].size;
      if (fileSize > 1024 * 1024 * 25) {
        event.currentTarget.value = '';
        this.file = null;
        alert('ファイルサイズが規定サイズを超えました');
        return;
      }
      this.file = event.target.files[0];
    },
    deleteFile() {
      const target = document.getElementById('file');
      target.value = '';
      this.file = null;
    },
    sendEmail() {
      let formData = new FormData();
      formData.append('name', 'inquiry');
      formData.append('image', this.file);
      this.inquiryData.userUid = this.currentUser.username;
      this.inquiryData.userRole = this.currentIDTypeTitle;
      const inquiryJsonData = JSON.stringify(this.inquiryData);
      formData.append('inquiryData', inquiryJsonData);
      MailService.sendInquiry(formData)
        .then(() => {
          this.$refs['popup_holder_success'].show();
        })
        .catch(() => {
          this.$refs['popup_holder_faild'].show();
        });
    },
    backToTop() {
      this.$router.push({ path: '/' });
    },
    backToContact() {
      this.$refs['popup_holder_faild'].hide();
    },
  },
  mounted() {
    if (this.currentUser.role == 'teacher') {
      this.inquiryData.name = this.currentUser.name;
    }
  },
};
</script>

<style scoped>
.container {
  padding: 30px;
}
.guidance {
  text-align: center;
  margin-bottom: 20px;
}
.form-container {
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.option-box {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.option {
  display: flex;
  align-items: center;
  width: calc(100% - 10px);
  padding: 10px;
  margin: 5px;
  border-radius: 5px;
  border: 1.5px solid #d3d3d3;
  cursor: pointer;
}
.no-pointer {
  cursor: inherit;
}
.deletefile-text {
  margin-left: 10px;
  color: #0000ff;
  text-decoration: underline;
  cursor: pointer;
}
input[type='checkbox'],
input[type='radio'] {
  transform: scale(1.3);
  margin: 0 10px 0 0;
}
input[type='text'] {
  width: 100%;
  border-radius: 5px;
  border: 1.5px solid #d3d3d3;
  padding: 10px;
  margin-top: 5px;
}
input[type='file'] {
  cursor: pointer;
}
textarea {
  width: 100%;
  height: 100px;
  border-radius: 5px;
  border: 1.5px solid #d3d3d3;
  padding: 10px;
  margin-top: 5px;
}
.headline {
  display: flex;
  gap: 10px;
}
.caution {
  font-size: 12px;
  color: #707070;
}
.bg-gray {
  background-color: #707070;
  color: #fff;
  font-size: 10px;
  padding: 3px 6px;
}
.not-require {
  margin-bottom: 10px;
}
.invalid-feedback {
  font-size: 14px;
}
input:focus,
textarea:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.is-valid {
  border-color: #28a745 !important;
}
.is-valid:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25) !important;
}
.is-invalid {
  border-color: #dc3545 !important;
}
.is-invalid:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}
.send {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
.send button {
  width: 40%;
  min-width: 250px;
}
</style>
